import { Routes, Route, Link } from "react-router-dom";
import LayoutNew from "./routes/new/layout";
import authCentral from "./services/authCentral";

//routes - AUTH / landing page
import LayoutNoTopBar from "./components/layouts/layoutNoTopBar";
import Layout from "./sitel/demon/ui/layout";
import WhoAreYou from "./routes/auth/whoAreYou";
import ContinueAuth from "./routes/auth/continue";
import Login from "./routes/auth/login";
import Step1CreateRequest from "./routes/auth/resetPassword/step1CreateRequest";
import Step2Login from "./routes/auth/resetPassword/step2Login";
import Step3ChangePassword from "./routes/auth/resetPassword/step3ChangePassword";

//routes - new user
import Step1ConfirmPage from "./routes/new/step1Confirm";
import Step2CredentialsPage from "./routes/new/step2Credentials";
import Step3EnterCodePage from "./routes/new/step3EnterCode";
import Step4VerifyCode from "./routes/new/step4VerifyCode";
import Step5Profile from "./routes/new/step5Profile";

//routes - existing user
import UserProfilePage from "./routes/user/profile";

function App() {
  //MAIN ROUTING LOGIC FOR THE APP
  return (
    <Routes>
      <Route path=":originApp">

        <Route element={<LayoutNoTopBar />}>
          <Route index element={<FigureOutWhoYouAre />} />
  
          <Route path="auth">
            <Route index element={<WhoAreYou />} />
            <Route path="continue" element={<ContinueAuth />} />
  
            <Route path="resetpassword">
              <Route path="step1/createrequest" element={<Step1CreateRequest />} />
              <Route path="step2/login" element={<Step2Login />} />
              <Route path="step3/changepassword" element={<Step3ChangePassword />} />
            </Route>
  
            <Route path="login/:medstarAssociationType" element={<Login />} />
            <Route path="login" element={<Login />} />
          </Route>{/* EOF: auth */}
  
          <Route path="new/:medstarAssociationType" element={<LayoutNew />}>
            <Route index element={<Step1ConfirmPage />} />
            <Route path="step1/confirm" element={<Step1ConfirmPage />} />
            <Route path="step2/credentials" element={<Step2CredentialsPage />} errorElement={Step1ConfirmPage} />
            <Route path="step3/entercode" element={<Step3EnterCodePage />} />
            <Route path="step4/verifycode/:sg1code" element={<Step4VerifyCode />} />
            <Route path="step5/profile" element={<Step5Profile />} />
          </Route>
  
        </Route>{/* EOF LayoutNoTopBar */}

        {authCentral.getCurrentUser() && (
          <Route path="user" element={<Layout homeRelativeUrl='/central' user={authCentral.getCurrentUser()} siteTitle="Profile"/>}>
            <Route path="profile/:editmode" element={<UserProfilePage />} />
          </Route>
        )}
          
      </Route>{/* EOF :originApp */}
          
      <Route path="continue-auth" element={<ContinueAuth />} />
      {authCentral.getCurrentUser() ? (
          <Route element={<Layout homeRelativeUrl='/central' user={authCentral.getCurrentUser()} siteTitle="Where to go"/>}>
            <Route path="*" element={<FigureOutWhoYouAre />} />
          </Route>
        ) 
        : 
          (<Route path="*" element={<FigureOutWhoYouAre />} />)
      }
          
    </Routes>
  );
}

export default App;

function FigureOutWhoYouAre() {

  return (
    <>
      <h2>Which MedStar Health service are you trying to access?</h2>
      <div className="list-group">
        <Link to="/sitelms/auth" className="list-group-item list-group-item-action">sitelms.org</Link>
        <a href="/oh-requests" className="list-group-item list-group-item-action">Create an exemption request with Occupational Health</a>
        <a href="/ssl-wizard" className="list-group-item list-group-item-action">SSL Wizard</a>
      </div>
    </>
  );
}
